import PageMeta from "components/PageMeta";
import { User } from "models/User";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { createUser } from "store/actions/Users";
import ManagedUserForm from "./ManagedUserForm";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

interface Actions { createUser: (user: User) => Promise<User>; }

const UserForm: React.FC<Actions> = ({ createUser }) => {
    const { t } = useOfficeTranslation();
    const [saving, setSaving] = useState(false);
    const navigate = useNavigate();
    const initial = Object.assign(new User(), { name: "", email: "", phone: "", region: "Europe", activated: true, level: 5, accounts: [] });
    const save = (user: User) => {
        setSaving(true);
        return Promise.resolve(createUser(user)).then(created => { navigate(`/users/${created.id}`); return created; }).finally(() => setSaving(false));
    };
    return <div className="page-content"><PageMeta title={t("common.addUser")} />
        <div className="page-title-box"><Link to="/users" className="text-muted"><i className="mdi mdi-arrow-left me-1" />{t("common.users")}</Link><h4 className="mt-2 mb-0">{t("common.addUser")}</h4></div>
        <Row><Col xl={9}><ManagedUserForm initial={initial} creating saving={saving} onSave={save} /></Col></Row>
    </div>;
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({ createUser }, dispatch);
export default connect(null, mapDispatchToProps)(UserForm);
